import { BookOpen } from "lucide-react";
import SeoLanding from "@/components/site/SeoLanding";

export default function CodeDeLaRoute() {
  return (
    <SeoLanding
      testId="page-code"
      seo={{
        title: "Code de la route Boulogne-Billancourt · cours en ligne illimités | DDSBillancourt",
        description: "Révisez le code de la route à Boulogne-Billancourt avec la plateforme e-learning DDSBillancourt : 36 cours structurés, quiz interactifs à 3 niveaux, suivi pédagogique en temps réel et accès illimité. Code inclus dans nos formules permis B.",
        path: "/code-de-la-route",
      }}
      breadcrumbName="Code de la route"
      badge="Code · E-learning"
      badgeIcon={BookOpen}
      h1="Code de la route en ligne à Boulogne-Billancourt"
      intro={[
        "Réussir l'examen du code (ETG) demande de la régularité, pas du bachotage la veille. Notre plateforme e-learning vous accompagne pas à pas, où que vous soyez : chez vous, dans le métro ou à l'agence de Boulogne-Billancourt.",
        "36 cours structurés couvrant les 4 compétences officielles, des quiz interactifs à 3 niveaux de difficulté avec explications pédagogiques détaillées, et un suivi de progression en temps réel par votre moniteur : c'est la méthode DDSBillancourt.",
      ]}
      formules={[
        {
          name: "Accès e-learning illimité",
          price: "10 €",
          priceNum: 10,
          highlight: true,
          features: ["36 cours structurés (4 compétences)", "Quiz interactifs à 3 niveaux", "Explications détaillées à chaque question", "Suivi pédagogique en temps réel", "Accès 24h/24, sur mobile et ordinateur", "Inclus gratuitement dans les formules permis B"],
        },
      ]}
      sections={[
        {
          title: "Une plateforme conçue par des moniteurs, pas un simple QCM",
          bullets: [
            { title: "36 cours progressifs", text: "circulation, priorités, signalisation, mécanique, éco-conduite, premiers secours… le programme officiel complet, débloqué au fil de votre progression." },
            { title: "Quiz gamifiés à 3 niveaux", text: "chaque cours se valide par des quiz chronométrés de difficulté croissante. Chaque réponse est expliquée : vous comprenez vos erreurs au lieu de les répéter." },
            { title: "Suivi par votre moniteur", text: "votre mentor voit votre progression en temps réel et adapte vos leçons de conduite en conséquence. Personne n'est laissé seul devant son écran." },
            { title: "Phrases à trous et cas pratiques", text: "des exercices variés qui font travailler la compréhension, pas seulement la mémoire." },
          ],
        },
        {
          title: "Comment se passe l'examen du code ?",
          paragraphs: [
            "L'épreuve théorique générale (ETG) comporte 40 questions ; il faut au moins 35 bonnes réponses pour être reçu. L'examen se passe dans un centre agréé (La Poste, SGS, Bureau Veritas…) — plusieurs centres se trouvent à Boulogne-Billancourt et dans les communes voisines, avec des sessions tous les jours.",
            "Une fois obtenu, le code reste valable 5 ans et permet jusqu'à 5 présentations à l'épreuve pratique. Nous vous inscrivons à l'examen dès que vos résultats sur la plateforme montrent que vous êtes prêt : nos élèves se présentent avec un taux de réussite bien supérieur à la moyenne.",
          ],
        },
        {
          title: "Nos conseils pour réussir du premier coup",
          bullets: [
            { title: "20 à 30 minutes par jour", text: "mieux vaut une séance courte quotidienne que 4 heures le dimanche. La plateforme est pensée pour ça." },
            { title: "Lisez les explications", text: "après chaque quiz, relisez les corrections détaillées — c'est là que se fait l'apprentissage." },
            { title: "Visez la régularité au niveau difficile", text: "quand vous enchaînez les quiz difficiles avec au maximum une faute, vous êtes prêt pour l'examen." },
          ],
        },
      ]}
      faq={[
        { q: "Le code est-il inclus dans les formules permis B ?", a: "Oui : l'accès illimité à la plateforme e-learning est compris dans nos formules 13 leçons (899 €) et 20 leçons (999 €). En accès seul, il est à 10 €." },
        { q: "Puis-je réviser le code uniquement en ligne ?", a: "Oui, la plateforme est accessible 24h/24 sur mobile et ordinateur. Votre progression est sauvegardée et suivie par votre moniteur, qui reste disponible pour répondre à vos questions." },
        { q: "Combien coûte le passage de l'examen du code ?", a: "L'inscription à l'examen dans un centre agréé (La Poste, SGS…) coûte 30 €, tarif réglementé identique partout en France." },
        { q: "En combien de temps peut-on obtenir le code ?", a: "Avec 20 à 30 minutes de révision par jour, la plupart de nos élèves sont prêts en 4 à 8 semaines. En révision intensive, c'est possible en 2 à 3 semaines." },
      ]}
      crossLinks={[
        { to: "/permis-boite-manuelle", label: "Permis boîte manuelle" },
        { to: "/permis-boite-automatique", label: "Permis boîte automatique" },
        { to: "/conduite-accompagnee", label: "Conduite accompagnée (AAC)" },
        { to: "/moto", label: "Permis moto" },
      ]}
    />
  );
}
